<template>
    <Modal class="edit-creator-modal" :is_show="is_show_edit_modal" @click-bg="close" :class="{ 'is-loading': is_loading }">
        <header class="edit-header">
            <h2>Edit Creator</h2>
            <i @click="close"><svg-icon name="close" /></i>
        </header>
        <Scrollbar>
            <!-- Creator Profile Header -->
            <div class="creator-header">
                <figure class="avatar">
                    <img :src="values.userProfile?.avatar_full_url" @error="imageError($event)" />
                </figure>
                <div class="name-inputs">
                    <div class="name-input-item">
                        <label class="label">First Name</label>
                        <el-input
                            size="large"
                            v-model="values.first_name"
                            placeholder="First name"
                            :disabled="permission_creator?.editBasicInfo?.permission === 0"
                            :class="{ 'is-error-input': validation_errors.first_name }"
                        />
                        <span v-if="validation_errors.first_name" class="field-error">{{ validation_errors.first_name }}</span>
                    </div>
                    <div class="name-input-item">
                        <label class="label">Last Name</label>
                        <el-input
                            size="large"
                            v-model="values.last_name"
                            placeholder="Last name"
                            :disabled="permission_creator?.editBasicInfo?.permission === 0"
                            :class="{ 'is-error-input': validation_errors.last_name }"
                        />
                        <span v-if="validation_errors.last_name" class="field-error">{{ validation_errors.last_name }}</span>
                    </div>
                </div>
            </div>

            <!-- Account Section -->
            <div class="info-section section-border">
                <div class="info-section-header">
                    <span class="section-label">Account</span>
                    <span class="section-date">Since {{ formatDate(values.created_at) }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Status</span>
                    <div class="info-value-right">
                        <span :class="['status-dot', anchor_status_display.dot]"></span>
                        <span :class="values.anchor_page_status === 100 ? 'text-active' : 'text-inactive'">
                            {{ anchor_status_display.text }}
                        </span>
                        <Switch
                            :disabled="!permission_creator?.disableCreators?.permission"
                            v-if="(values.status === 100 && values.anchor_page_status === 100) || (values.status === 100 && values.anchor_page_status === 0)"
                            :checked="values.anchor_page_status === 100"
                            @click="handleStoreFront"
                        />
                    </div>
                </div>
                <div class="info-row">
                    <span class="info-label">Type</span>
                    <div class="info-value-right">
                        <span v-if="is_link_only" class="info-text">Links</span>
                        <el-select v-else-if="permission_creator?.disableCreators?.permission === 100" v-model="platform_type" class="account-type-select" :teleported="true" popper-class="account-type-popper">
                            <el-option label="Storefront" value="storefront" />
                            <el-option label="Links" value="linkonly" />
                        </el-select>
                        <span v-else class="info-text">{{ values.platform_type === 'linkonly' ? 'Links' : 'Storefront' }}</span>
                    </div>
                </div>
                <div class="info-row">
                    <span class="info-label">Motom</span>
                    <div class="info-value-right">
                        <span :class="['status-dot', values.status === 100 ? 'active' : 'inactive']"></span>
                        <span :class="values.status === 100 ? 'text-active' : 'text-inactive'">
                            {{ values.status === 100 ? 'Joined' : 'Pending' }}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Account Email -->
            <div class="info-section section-border" v-if="route.path === '/creator/get-started' || (!is_recuruitment_creator_email || store.state.user_data.is_motom_internal_user)">
                <label class="section-field-label">Account Email</label>
                <el-input
                    v-if="values.anchor_page_status === 20"
                    size="large"
                    v-model="values.email"
                    placeholder="Enter a valid email"
                    :disabled="permission_creator?.editBasicInfo?.permission === 0"
                    :class="{ 'is-error-input': validation_errors.email }"
                />
                <p v-else-if="values.original_email || values.email"><a :href="'mailto:' + (values.original_email || values.email)">{{ values.original_email || values.email }}</a></p>
                <p v-else>---</p>
                <span v-if="validation_errors.email" class="field-error">{{ validation_errors.email }}</span>
            </div>

            <!-- Creator Tags -->
            <div class="info-section coll-chec program-tag-box-big">
                <label class="section-field-label">Creator tags</label>
                <dl class="tag-line program-tag-box" v-if="permission_creator?.addOrEditCreatorTags?.permission || values.merchant_account_tags?.length > 0">
                    <dd v-if="values.merchant_account_tags !== undefined" :class="['program-tag-box-dd','edit-program-tag-box-dd']">
                        <div @click.stop="values.tag_open = !values.tag_open; values.tag_all_open = false;" class="add-tag-btn" v-if="permission_creator?.addOrEditCreatorTags?.permission">
                            <svg-icon name="tag-plus" />
                        </div>
                        <Badage class="tag-item-box" v-for="(v, k) in values.merchant_account_tags?.filter((_, kk) => kk < 8)" :key="k" :value="v.text" :show_tippy="true">
                            <svg-icon name="close" @click.stop="handleSelectTag({ tag: v, row: values })" v-if="permission_creator?.addOrEditCreatorTags?.permission" />
                        </Badage>
                        <Badage @click.stop="values.tag_all_open = !values.tag_all_open; values.tag_open = false;" v-if="values.merchant_account_tags?.length - 8 > 0" :value="`+${values.merchant_account_tags.length - 8}`" />
                    </dd>
                </dl>
                <span class="tag-line" v-else>---</span>
                <DropdownHashtag
                    :tags="values.tags"
                    :selected_tags="values.merchant_account_tags"
                    :tag_type="'creator_tag'"
                    @select-tag="selectTagHandler"
                    @closeKey="values.tag_open = false"
                    :open_key="values.tag_open"
                    :row="values"
                    :drop_css="'top:unset;left:0px;bottom:36px'"
                    :index="9999"
                />
                <HashtagPopup
                    :tags="values.merchant_account_tags"
                    :row="values"
                    :open_key="values.tag_all_open"
                    :drop_css="'top:unset;left:0px;bottom:36px'"
                    :index="9999"
                    @closeKey="values.tag_all_open = false;"
                    @open-cre-tag="values.tag_open = true; values.tag_all_open = false;"
                />
            </div>

            <!-- Chat -->
            <div class="info-section" v-if="store.state.user_data?.merchant_account?.is_enable_chatroom">
                <div class="chat-header-row">
                    <label class="section-field-label">Chat</label>
                    <div class="chat-status-right">
                        <span :class="values.chatroom_is_disable !== 1 ? 'text-active' : 'text-inactive'">
                            {{ values.chatroom_is_disable !== 1 ? 'Active' : 'Disabled' }}
                        </span>
                        <Switch
                            :checked="values.chatroom_is_disable !== 1"
                            @click="setChatroom(1)"
                            :disabled="permission_creator?.editChatPermissions?.permission === 0"
                        />
                    </div>
                </div>
                <p class="section-desc">Controls the ability to send and receive messages with this creator.</p>
                <template v-if="values.chatroom_is_disable !== 1">
                    <div class="switch-inline-row-block">
                        <div class="switch-inline-row">
                            <strong>Block Replies</strong>
                            <Switch
                                :checked="values.chatroom_is_mute === 1"
                                @click="setChatroom(2)"
                                :disabled="permission_creator?.editChatPermissions?.permission === 0"
                            />
                        </div>
                        <p class="section-desc">Outbound messages remain enabled. The creator cannot reply or send direct messages.</p>
                    </div>
                </template>
            </div>

            <!-- Social Accounts -->
            <div class="info-section">
                <label class="section-field-label">Social Accounts</label>
                <p class="desc">{{ is_sephora? 'A creator may authenticate any social handle provided by Sephora in order to validate their Sephora creator account.  Once connected, you will not be able to edit this section.':'We use this to authenticate Motom creator profiles. Once they have connected their social accounts, you will not be able to edit this section.'}}</p>
                <div class="social-accounts-list">
                    <div class="social-account-item" v-if="can_edit_tiktok_handle || values.tiktok_handle">
                        <svg-icon name="tiktok" />
                        <el-input
                            v-if="can_edit_tiktok_handle"
                            class="social-handle-input"
                            size="large"
                            v-model="values.tiktok_handle"
                            placeholder="@username"
                            :disabled="permission_creator?.editBasicInfo?.permission === 0"
                        />
                        <template v-else>
                            <span class="social-handle">{{ values.tiktok_handle.startsWith('@') ? '' : '@' }}{{ values.tiktok_handle }}</span>
                            <span :class="['soc-state', 'class-' + values.tiktok_connect_status]">{{ soc_status_text(values.tiktok_connect_status) }}</span>
                        </template>
                    </div>
                    <div class="social-account-item" v-if="can_edit_instagram_handle || values.instagram_handle">
                        <svg-icon name="instagram" />
                        <el-input
                            v-if="can_edit_instagram_handle"
                            class="social-handle-input"
                            size="large"
                            v-model="values.instagram_handle"
                            placeholder="username"
                            :disabled="permission_creator?.editBasicInfo?.permission === 0"
                        />
                        <template v-else>
                            <span class="social-handle">{{ values.instagram_handle.startsWith('@') ? '' : '@' }}{{ values.instagram_handle }}</span>
                            <span :class="['soc-state', 'class-' + values.instagram_connect_status]">{{ soc_status_text(values.instagram_connect_status) }}</span>
                        </template>
                    </div>
                    <div v-if="!can_edit_tiktok_handle && !can_edit_instagram_handle && !values.tiktok_handle && !values.instagram_handle">
                        <span class="social-handle">---</span>
                    </div>
                    <span v-if="validation_errors.social_handle" class="field-error">{{ validation_errors.social_handle }}</span>
                </div>
            </div>

            <!-- Collections -->
            <div class="info-section" v-if="!is_link_only && platform_type !=='linkonly' ">
                <label class="section-field-label">Collections</label>
                <Checkbox
                    :checked="!!values.is_allow_customize_collection_cover"
                    label_text="Allow the creator to upload custom cover images to storefront collections."
                    :align_start="true"
                    @click="values.is_allow_customize_collection_cover = !values.is_allow_customize_collection_cover"
                />
            </div>

            <!-- Save -->
            <div class="btn-wrap">
                <el-button class="save-btn" type="primary" @click="submit" :loading="is_loading">Save</el-button>
            </div>
        </Scrollbar>
    </Modal>

    <!-- Alert Modals -->
    <Modal :is_show="is_show_alert_modal" class="alert-modal width-380" @click-bg="is_show_alert_modal = false">
        <div class="box">
            <header class="delete-header" v-if="values.status === 100 && values.anchor_page_status === 100">
                {{ modal_is_link_only ? 'Disable links? ' : 'Disable storefronts?' }}
            </header>
            <header class="delete-header" v-else-if="values.status === 100 && values.anchor_page_status === 0">
                {{ modal_is_link_only ? 'Activate links?' : 'Activate storefronts?' }}
            </header>
            <p v-if="values.status === 100 && values.anchor_page_status === 100">
                {{
                modal_is_link_only
                    ? 'Selected creators will no longer be able to create new links. Existing link data will remain in the portal.'
                    : 'The storefront links will no longer be active, but all of the data will remain in the Anchor portal.'
                }}
            </p>
            <p v-else-if="values.status === 100 && values.anchor_page_status === 0">
                {{
                modal_is_link_only
                    ? 'Selected creators will be able to create and share links. '
                    : '1 selected creator ready to activate storefront.'
                }}
            </p>
            <div class="btns">
                <el-button @click="toggle(1)">Cancel</el-button>
                <el-button type="primary" @click="toggle(2)">
 
                    {{ values.anchor_page_status === 100 ? 'Disable' : 'Activate' }}
                </el-button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_alert_modal2" class="alert-modal width-380" @click-bg="is_show_alert_modal2 = false">
        <div class="box">
            <header class="delete-header">Disable conversation?</header>
            <p>Both you and creator will no longer be able to send messages to each other.</p>
            <div class="btns">
                <el-button @click="is_show_alert_modal2 = false">No</el-button>
                <el-button type="primary" @click="is_show_alert_modal2 = false; values.chatroom_is_disable = 1">Yes, confirm</el-button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_alert_modal3" class="alert-modal" @click-bg="is_show_alert_modal3 = false">
        <div class="box">
            <header class="delete-header">Block/Mute conversation?</header>
            <p>Once muted, you can still send messages to this creator, however this creator will no longer be able to send messages to you.</p>
            <div class="btns">
                <el-button @click="is_show_alert_modal3 = false">No</el-button>
                <el-button type="primary" @click="is_show_alert_modal3 = false; values.chatroom_is_mute = 1">Yes, confirm</el-button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_alert_modal4" class="alert-modal" @click-bg="is_show_alert_modal4 = false">
        <div class="box">
            <header class="delete-header">Can't enable conversation</header>
            <p>This storefront currently is disabled, you can't enable a conversation without re-enabling the storefront.</p>
            <div class="btns">
                <el-button type="primary" @click="is_show_alert_modal4 = false">Ok</el-button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_platform_type_modal" class="alert-modal width-380" @click-bg="is_show_platform_type_modal = false">
        <div class="box">
            <template v-if="platform_type === 'storefront'">
                <header class="delete-header">Enable Storefront</header>
                <p>This creator's storefront will be enabled immediately.</p>
            </template>
            <template v-else-if="platform_type === 'linkonly'">
                <header class="delete-header">Change Account Type</header>
                <p>Storefront access will be removed. Storefront data will be retained.</p>
            </template>
            <div class="btns">
                <el-button @click="is_show_platform_type_modal = false">Cancel</el-button>
                <el-button type="primary" @click="confirmPlatformTypeChange">Confirm</el-button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="tag_remove_modal" class="alert-modal" @click-bg="tag_remove_modal = false">
        <div class="box remove-box" v-if="projectName === 'sephora' && handle_remove_tag_value.tag?.text === 'elevated'">
            <header class="delete-header">Remove the tag linked to the creator's storefront template?</header>
            <p>You're about to remove the 'Elevated' tag, which is linked to a custom storefront template for the creator. Once removed, the creator's storefront will revert to the standard basic template, and some functionality from the current template will be limited.</p>
            <p>Are you sure you want to proceed?</p>
            <div class="btns">
                <el-button @click.stop="tag_remove_modal = false">Cancel</el-button>
                <el-button type="primary" @click.stop="tag_remove_modal = false; selectTagHandler(handle_remove_tag_value, 'from_outside')">Confirm</el-button>
            </div>
        </div>
        <div class="box remove-box" v-else>
            <header class="delete-header">Remove tag</header>
            <p>Are you sure you want to remove the "{{ handle_remove_tag_value.tag?.text }}" tag?</p>
            <div class="btns">
                <el-button @click.stop="tag_remove_modal = false">No</el-button>
                <el-button type="primary" @click.stop="tag_remove_modal = false; selectTagHandler(handle_remove_tag_value, 'from_outside')">Yes, confirm</el-button>
            </div>
        </div>
    </Modal>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { ElButton, ElSelect, ElOption, ElInput } from 'element-plus';

import Modal from '@/components/ui/Modal.vue';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Badage from '@/components/ui/Badage.vue';
import HashtagPopup from '@/components/HashtagPopup.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import { getTags, handleCreTag, selectTag } from '@/utils/CreatorTagFun';
import defaultAvatar from '@/assets/images/user.png';

// Global properties
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const projectName = app.appContext.config.globalProperties.$ProjectName;
const EventBus = app.appContext.config.globalProperties.EventBus;
const store = useStore();
const route = useRoute();
const router = useRouter();

// Emits
const emit = defineEmits(['save']);

// Refs
const is_loading = ref(false);
const is_show_edit_modal = ref(false);
const is_show_alert_modal = ref(false);
const is_show_alert_modal2 = ref(false);
const is_show_alert_modal3 = ref(false);
const is_show_alert_modal4 = ref(false);
const is_can_delete = ref(false);
const is_error = ref(false);
const error_msg = ref('');
const values = ref({});
const all_tags = ref([]);
const tag_remove_modal = ref(false);
const handle_remove_tag_value = ref({ row: null, tag: '' });
const check_not_enable_creator = ref(0);
const platform_type = ref('linkonly');
const original_platform_type = ref('');
const is_show_platform_type_modal = ref(false);
const validation_errors = ref({
    first_name: '',
    last_name: '',
    email: '',
});

// Computed
const permission_creator = computed(() => {
    return store.state.user_data?.permission_list?.creatorManagement;
});

const is_link_only = computed(() => {
    return store.state.user_data?.merchant_account.platform_type === 'linkonly';
});

const modal_is_link_only = computed(() => {
    return is_link_only.value || platform_type.value === 'linkonly';
});

const is_recuruitment_creator_email = computed(() => {
    return values.value.original_email==null && values.value.email!=null
});

// same text/color mapping as the storefront status column in views/creator/List.vue
const anchor_status_display = computed(() => {
    switch (values.value.anchor_page_status) {
        case 100: return { text: 'Active', dot: 'active' };
        case 0:   return { text: 'Disabled', dot: 'pending' };
        case 20:  return { text: 'Added', dot: 'pending' };
        case -10: return { text: 'Declined', dot: 'declined' };
        case 10:  return { text: 'Unavailable', dot: 'pending' };
        default:  return { text: 'Invited', dot: 'pending' };
    }
});

// Active(100) / Disabled(0) / Declined(-10) / Unavailable(10) creators cannot change
// social handles; Added(20) / Invited(any other value) can — except a handle whose
// social account is already fully connected (20/25), same rule as the backend
// edit_tiktok_handle / edit_instagram_handle flags.
const can_edit_social_handle = computed(() => {
    return ![100, 0, -10, 10].includes(values.value.anchor_page_status);
});

const can_edit_tiktok_handle = computed(() => {
    return can_edit_social_handle.value && ![20, 25].includes(values.value.tiktok_connect_status);
});

const can_edit_instagram_handle = computed(() => {
    return can_edit_social_handle.value && ![20, 25].includes(values.value.instagram_connect_status);
});

const soc_status_text = (status) => {
    switch (status) {
        case 0:  return 'Not Connected';
        case 10: return 'Partial Connected';
        case 15: return 'Expired';
        case 20: return 'Fully Connected';
        case 25: return 'Expired';
        default: return '';
    }
};

// Methods
const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    return d.toLocaleDateString('en-US', options);
};

const validateForm = () => {
    let isValid = true;
    validation_errors.value = { first_name: '', last_name: '', email: '' };

    if (!values.value.first_name || values.value.first_name.trim() === '') {
        validation_errors.value.first_name = 'Cannot leave blank.';
        isValid = false;
    }
    if (!values.value.last_name || values.value.last_name.trim() === '') {
        validation_errors.value.last_name = 'Cannot leave blank.';
        isValid = false;
    }
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{1,}$/;
    const is_cj = store.state.projectName === 'cj';
    if (is_cj) {
        if (!values.value.email || values.value.email.trim() === '') {
            validation_errors.value.email = 'Cannot leave blank.';
            isValid = false;
        } else if (!emailRegex.test(values.value.email)) {
            validation_errors.value.email = 'Invalid email address.';
            isValid = false;
        }
    } else {
        if (values.value.email && values.value.email.trim() !== '') {
            if (!emailRegex.test(values.value.email)) {
                validation_errors.value.email = 'Invalid email address.';
                isValid = false;
            }
        }
        // backend requires at least one of tiktok_handle / instagram_handle / email
        if (can_edit_social_handle.value
            && !values.value.tiktok_handle?.trim()
            && !values.value.instagram_handle?.trim()
            && !(values.value.email || values.value.original_email)) {
            validation_errors.value.social_handle = 'Please provide at least one social handle or email.';
            isValid = false;
        }
    }
    return isValid;
};

const handleStoreFront = () => {
    if (!permission_creator.value?.disableCreators?.permission) return;
    is_show_alert_modal.value = true;
};

const setChatroom = (type) => {
    if (permission_creator.value?.editChatPermissions?.permission === 0) return;
    if (values.value.anchor_page_status !== 100) {
        is_show_alert_modal4.value = true;
        return;
    }
    if (type === 1) {
        if (values.value.chatroom_is_disable !== 1) {
            is_show_alert_modal2.value = true;
        } else {
            values.value.chatroom_is_disable = 0;
        }
    } else if (type === 2) {
        if (values.value.chatroom_is_mute !== 1) {
            is_show_alert_modal3.value = true;
        } else {
            values.value.chatroom_is_mute = 0;
        }
    }
};

const toggle = (type) => {
    is_show_alert_modal.value = false;
    if (type === 2) {
        if (values.value.anchor_page_status === 100) {
            values.value.anchor_page_status = 0;
            values.value.anchor_page_status_text = 'Disabled';
        } else if (values.value.anchor_page_status === 0) {
            values.value.anchor_page_status = 100;
            values.value.anchor_page_status_text = 'Active';
        }
    }
};

const deleteCreator = () => {
    EventBus.emit('delete-creator', values.value.id);
};

const submit = () => {
    if (!validateForm()) return;

    if (!is_link_only.value && platform_type.value !== original_platform_type.value) {
        is_show_platform_type_modal.value = true;
        return;
    }

    doSubmit();
};

const confirmPlatformTypeChange = () => {
    is_show_platform_type_modal.value = false;
    doSubmit();
};

const doSubmit = () => {
    is_error.value = false;
    is_loading.value = true;

    if (values.value.tiktok_handle) {
        values.value.tiktok_handle = values.value.tiktok_handle.replace(/@/gi, '');
    }

    values.value.is_allow_customize_collection_cover = values.value.is_allow_customize_collection_cover ? 1 : 0;
    values.value.platform_type = platform_type.value;

    ajax('/creator/edit', {
        method: 'post',
        data: values.value,
    }).then(res => {
        close();
        res.data.data.merchant_account_tags = values.value.merchant_account_tags;
        res.data.data.platform_type = platform_type.value;
        emit('save', res.data.data);
        EventBus.emit('update-table-creator');
        is_loading.value = false;
    }).catch(err => {
        is_loading.value = false;
        if (err?.response?.data?.data) {
            is_error.value = true;
            error_msg.value = err.response.data.data.message;
        }
    });
};

const fetchTags = async () => {
    const context = { $ajax: ajax };
    let tagData = await getTags(context);
    if (tagData.data) {
        all_tags.value = tagData.orgData;
    }
};

const open = async (data, num) => {
    if (num) check_not_enable_creator.value = num;

    await fetchTags();
    const clone_obj = JSON.parse(JSON.stringify(data));
    is_error.value = false;
    error_msg.value = '';
    console.log('clone_obj',clone_obj)
    values.value = clone_obj;
    values.value.anchor_creator_id = clone_obj.id;
    validation_errors.value = { first_name: '', last_name: '', email: '' };

    if (!values.value.userProfile) {
        values.value.userProfile = { avatar_full_url: defaultAvatar };
    }

    platform_type.value = is_link_only.value ? 'linkonly' : clone_obj.platform_type;
    original_platform_type.value = platform_type.value;
    handleCreTag(values.value, all_tags.value);

    is_can_delete.value = (clone_obj.status === 10 ||
        ((clone_obj.status === 100 && clone_obj.anchor_page_status === 10) ||
         (clone_obj.status === 100 && clone_obj.anchor_page_status === 20) ||
         (clone_obj.status === 100 && clone_obj.anchor_page_status === -10)));

    is_show_edit_modal.value = true;
};

const close = () => {
    is_show_edit_modal.value = false;
    is_error.value = false;
    error_msg.value = '';
    validation_errors.value = { first_name: '', last_name: '', email: '' };
    EventBus.emit('update-modal-creator');
};

const imageError = (event) => {
    event.target.src = defaultAvatar;
};

const selectTagHandler = (item, spec_text) => {
    const context = { $ajax: ajax, values: values.value, all_tags: all_tags.value };
    selectTag(item, spec_text, context);
};

const handleSelectTag = (item) => {
    handle_remove_tag_value.value.row = item.row;
    handle_remove_tag_value.value.tag = item.tag;
    tag_remove_modal.value = true;
};

defineExpose({ open, close });
</script>

<style lang="scss">
.edit-creator-modal {
    .ui-modal--container {
        background-color: var(--bg-01);
        width: 620px;
        padding: 16px 24px;
        max-height: 90vh;

        .scrollbar-content {
            max-height: calc(90vh - 100px);
            padding-right: 4px;
        }
    }

    .edit-header {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        h2 {
            font: var(--font-med-20);
            color: var(--black-90);
            flex: 1;
            line-height: 1;
        }

        i {
            height: 12px;
            width: 12px;
            position: relative;
            display: block;
            cursor: pointer;

            svg {
                height: 12px;
                width: 12px;
                fill: var(--black-50);
            }
        }
    }

    .svg-icon--checked{
        margin: 0;
        margin-right: 6px;
    }

    .creator-header {
        display: flex;
        align-items: center;
        gap: 16px;
        margin-bottom: 12px;

        .avatar {
            width: 68px;
            height: 68px;
            flex-shrink: 0;
            margin-top: 20px;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
                border: 1px solid var(--black-20);
            }
        }

        .name-inputs {
            display: flex;
            gap: 12px;
            flex: 1;

            .name-input-item {
                flex: 1;

                .label {
                    display: block;
                    font: var(--font-med-14);
                    color: var(--black-75);
                    margin-bottom: 4px;

                    &:after {
                        content: ' *';
                        color: var(--alert);
                    }
                }

                .el-input {
                    width: 100%;
                }

                .field-error {
                    display: block;
                    font-size: 11px;
                    color: var(--alert);
                    margin-top: 3px;
                }
            }
        }
    }

    .info-section {
        &.section-border{
            border-top: 1px solid var(--black-10);
            padding-top: 12px;
        }
        
        padding: 8px 0;

        .info-section-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 8px;

            .section-label {
                font: var(--font-med-16);
                color: var(--black-90);
            }

            .section-date {
                font: var(--font-fg-12);
                color: var(--black-50);
            }
        }

        .section-field-label {
            display: block;
            font: var(--font-med-16);
            color: var(--black-90);
            margin-bottom: 8px;
        }

        .section-desc {
            font-size: 16px;
            color: var(--black-60);
            margin: 4px 0 8px;
            line-height: 1.5;
        }

        .info-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 6px 0;

            .info-label {
                font: var(--font-med-14);
                color: var(--black-90);
            }

            .info-value-right {
                display: flex;
                align-items: center;
                gap: 6px;

                .info-text {
                    font: var(--font-fg-14);
                    color: var(--black-90);
                }

                .status-dot {
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;

                    &.active { background-color: var(--green); }
                    &.inactive { background-color: var(--black-40); }
                    &.pending { background-color: var(--yellow); }
                    &.declined { background-color: var(--alert); }
                }

                .text-active {
                    font: var(--font-med-12);
                }

                .text-inactive {
                    color: var(--black-60);
                    font: var(--font-fg-14);
                }

                .account-type-select {
                    width: 180px;

                    .el-input__wrapper {
                        box-shadow: none;
                        border: 1px solid var(--black-20);
                    }
                }
            }
        }

        .el-input {
            width: 100%;
        }

        .field-error {
            display: block;
            font-size: 11px;
            color: var(--alert);
            margin-top: 3px;
        }

        .is-error-input .el-input__wrapper {
            border-color: var(--alert) !important;
            box-shadow: 0 0 0 1px var(--alert) !important;
        }

        // Chat
        .chat-header-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 4px;

            .chat-status-right {
                display: flex;
                align-items: center;
                gap: 8px;

                .text-active {
                    font: var(--font-med-12);
                }
            }
        }

        .switch-inline-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 4px 0;

            strong {
                font: var(--font-med-14);
                color: var(--black-90);
            }
        }

        .switch-inline-row-block {
            border-left: 2px solid var(--black-20);
            padding-left: 16px;
        }

        .my-badges-iden{
            display: flex;
            gap: 4px;
            align-items: center;
            svg{
                width: 10px;
                height: 10px;
                fill: var(--black-75);
            }
        }

        // Social
        .social-accounts-list {
            .social-account-item {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 6px 0;

                svg {
                    width: 16px;
                    height: 16px;
                    fill: var(--black-75);
                    flex-shrink: 0;
                }

                .social-handle {
                    font: var(--font-fg-14);
                    color: var(--black-90);
                    flex: 1;
                }

                .social-handle-input {
                    flex: 1;
                }

                .social-status {
                    font: var(--font-fg-12);

                    &.connected { color: var(--green); }
                    &.expired { color: var(--alert); }
                }
            }
        }

        // Tags
        &.coll-chec {
            .program-tag-box {
                border-radius: 6px;
                margin: 0;
                display: flex;
                align-items: center;
                position: relative;

                dd {
                    &.program-tag-box-dd {
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding: 4px;
                        gap: 6px;
                        flex: 1;

                        &.edit-program-tag-box-dd {
                            border: solid 1px var(--neutral);
                            border-radius: 6px;
                        }

                        .add-tag-btn {
                            padding: 4px;
                            border: solid 1px var(--neutral);
                            border-radius: 6px;
                            height: 24px;
                            display: flex;
                            align-items: center;

                            .svg-icon {
                                margin: unset;
                                width: 14px;
                            }
                        }
                    }
                }
            }

            .tag-line {
                display: flex;
                align-items: center;
            }
        }
    }

    .btn-wrap {
        position: sticky;
        bottom: 0;
        background: var(--white);
        padding: 16px 0 0;

        .save-btn {
            width: 100%;
            background-color: var(--black-20);
            border: none;
            color: var(--black-50);

            &:not(:disabled) {
                background-color: var(--dark-blue);
                color: white;
            }
        }
    }

    &.is-loading {
        .creator-header,
        .info-section,
        .btn-wrap {
            opacity: 0.5;
            pointer-events: none;
        }
    }

    .soc-state{
        font:var(--font-med-12);
        display: inline-flex;
        align-items: center;
        line-height: 18px;

        &::before {
            height: 8px;
            width: 8px;
            content: "";
            display: block;
            border-radius: 50%; /* 完整圓形 */
            background: linear-gradient(to right, var(--yellow) 50%, transparent 50%); /* 左半邊填充顏色 */
            border: 1px solid var(--yellow); /* 整個圓的邊框 */
            margin-right: 5px;
        }

        //fully connected 
        &.class-20{
            &::before {
                background: var(--green);
                border: 1px solid var(--green);
            }
        }

        //partial connected
        &.class-10{
            &::before {
                background: linear-gradient(to right, var(--green) 50%, transparent 50%); /* 左半邊填充顏色 */
                border: 1px solid var(--green); /* 整個圓的邊框 */
            }
        }

        //fully connected expired
        &.class-25{
            &::before {
                background:var(--alert);
                border: 1px solid var(--alert);
            }
        }

        //partial connected expired
        &.class-15{
            &::before {
                background: linear-gradient(to right, var(--alert) 50%, transparent 50%); /* 左半邊填充顏色 */
                border: 1px solid var(--alert); /* 整個圓的邊框 */
            }
        }

        //not connected
        &.class-0{
            &::before {
                background: var(--neutral); 
                border: 1px solid var(--neutral); /* 整個圓的邊框 */
            }
        }
    }
}

.alert-modal {
    .box {
        padding: 24px;

        .delete-header {
            font: var(--font-demi-18);
            color: var(--black-90);
            margin-bottom: 12px;
        }

        p {
            font: var(--font-fg-14);
            color: var(--black-75);
            margin-bottom: 16px;
        }

        .btns {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
        }
    }
}

.width-380 {
    .ui-modal--container {
        width: 380px !important;
    }
}

.account-type-popper {
    z-index: 9999 !important;
    margin-left: 0 !important;
    width: unset !important;
}
</style>
